import React from "react";
import gamerjilogo from "../assets/images/gamerjilogo.png";
import underlineimage from "../assets/images/title-shape.png";

const Clients = () => {
  const logos = [
    { alt: "Logo 1", src: gamerjilogo },
    { alt: "Logo 2", src: gamerjilogo },
    { alt: "Logo 3", src: gamerjilogo },
    { alt: "Logo 4", src: gamerjilogo },
  ];

  return (
    <div
      className="text-center py-16 px-4 md:px-10 lg:px-20 overflow-hidden bg-white"
      style={{
        backgroundSize: "100%",
        backgroundColor: "#070b28",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom 15px center",
      }}
    >
      {/* Title */}
      <h2
        className="text-[36px] md:text-[48px] font-oswald font-extrabold text-[#ffffff] cursor-pointer"
     
      >
        Clients
      </h2>

      {/* Underline */}
      <img
        src={underlineimage}
        alt="underline"
        className="mx-auto mt-2 mb-6 w-[120px] h-auto"
      />

      {/* Logo marquee area */}
      <div className="relative w-full bg-[#070b28] py-10 overflow-hidden">
        <div className="relative max-w-7xl mx-auto overflow-hidden px-4 md:px-0">
          {/* Left fade effect */}
          <div className="pointer-events-none absolute top-0 left-0 h-full w-24 z-10 bg-gradient-to-r from-[#070B28] to-transparent" />

          {/* Right fade effect */}
          <div className="pointer-events-none absolute top-0 right-0 h-full w-24 z-10 bg-gradient-to-l from-[#070B28] to-transparent" />

          {/* Scrolling logos */}
          <div className="flex gap-12 animate-marqueeLeft w-max">
            {[...logos, ...logos].map((logo, index) => (
              <img
                key={index}
                alt={logo.alt}
                src={logo.src}
                className="max-w-56 w-fit h-auto max-h-16"
                loading="lazy"
                style={{ color: "transparent" }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clients;
